// extracted by mini-css-extract-plugin
export var container = "section-contact-form-module--container--d1yYI";
export var contents = "section-contact-form-module--contents--fKujY";
export var modal_contents = "section-contact-form-module--modal_contents--E16Wk";
export var title = "section-contact-form-module--title--IKefT";
export var input_wrap = "section-contact-form-module--input_wrap--4IRhV";
export var form_require = "section-contact-form-module--form_require--uwExR";
export var select_area = "section-contact-form-module--select_area--3iSeM";